import { Box, Callout, CalloutType } from '@factorialco/deprecated-design-system'

export const BoxedCallout: React.FC<{
  description: string
  type?: CalloutType
  fullWidth?: boolean
}> = ({ description, type = 'info', fullWidth = false }) => {
  return (
    <Box width={fullWidth ? 'full' : undefined}>
      <Callout type={type} description={description} />
    </Box>
  )
}
